import classNames from 'classnames';
import { ButtonHTMLAttributes, forwardRef } from 'react';

import styles from './CleanButton.module.css';

type CleanButtonProps = {
    fullWidth?: boolean;
    fullHeight?: boolean;
    preventDrag?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const CleanButton = forwardRef<HTMLButtonElement, CleanButtonProps>(
    (
        {
            children,
            className,
            type = 'button',
            fullWidth = false,
            fullHeight = false,
            preventDrag = false,
            disabled,
            ...buttonProps
        },
        ref
    ) => (
        <button
            ref={ref}
            type={type}
            className={classNames(
                styles.Root,
                fullWidth && styles.fullWidth,
                fullHeight && styles.fullHeight,
                disabled && styles.disabled,
                className
            )}
            draggable={preventDrag ? false : undefined}
            disabled={disabled}
            {...buttonProps}
        >
            {children}
        </button>
    )
);

export default CleanButton;
